// JavaScript Document
//components/configuration/standard/forms/beacon.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
//import Switch from '@material-ui/core/Switch';
//import FormGroup from '@material-ui/core/FormGroup';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap: "wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
	advancedContentVertical: {
		display: "flex",
		alignItems:"stretch",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap"
	},
	miniOnOff: {
		display: "flex",
		alignItems:"center",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap",
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function Beacon(props) {
  	const classes = useStyles();
	//inherited variables
  	const {id, timing, onChange} = props;
	//locally stored/copied variables
	const [cid, setCid] = React.useState(0);
	//local state varialbes user will change
	const [mtime, setMtime] = React.useState({
		steps:[[500, 500], [500, 500], [500, 500], [500, 500]],
		duration:8,
		cycles:2
	});
	
	//Local constant for maximum value
	const max = 65535;
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(
			//inherited config ID is null
			cid === 0 || 
			cid === undefined || 
			cid === null || 
			cid === "0" || 
			//inherited daysetting has changed
			cid !== id 
			//updated from server
			//|| loadedToken != token
		) {
			//console.log('config has changed');
			setCid(id);
			let newTiming = Object.assign({}, timing);
			newTiming.cycles = calcCycles(timing);
			setMtime(newTiming);
		}
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//Calculate cycles from timing
	const calcCycles = (times) => {
		let cycleLength = times.steps.flat().reduce((prev, cur) => parseInt(prev) + parseInt(cur), 0);
		return Math.round(times.duration * 1000 / cycleLength);
	}
	
	//Calculate duration from cycles
	const calcDuration = (times) => {
		let cycleLength = times.steps.flat().reduce((prev, cur) => parseInt(prev) + parseInt(cur), 0);
		return Math.ceil(cycleLength * times.cycles / 100) / 10;
	}
	
	//Handle update parent if onChange is provided
	const handleUpdateParent = (newTiming) => {
		if(onChange){
			console.log('Updating parent');
			onChange(newTiming);
		}
	}
	

	
	//handle change timing value
	const handleChangeTiming = (e, num) => {
		let setting = e.target.name;
		let value = parseInt(e.target.value);
		let newTime = Object.assign({}, mtime);
		//clean the value
		if(['duration', 'cycles'].indexOf(setting) !== -1){
			if(isNaN(value) || value < 0){
				value = 0;
			} else if(value > 255){
				value = 255;
			}
			if(setting === 'duration'){
				//calculate the cycles
				newTime.duration = value;
				newTime.cycles = calcCycles(newTime);
			} else if(setting === 'cycles'){
				newTime.cycles = value;
				newTime.duration = calcDuration(newTime);
			}
		} else {
			if(isNaN(value) || value < 0){
				value = 0;
			} else if(value > max){
				value = max;
			}
			if(setting === 'on'){
				newTime.steps[num][0]=value;
			} else if(setting === 'off'){
				newTime.steps[num][1]=value;
			}
			//recalculate cycles
			newTime.cycles = calcCycles(newTime);
		}
		setMtime(newTime);
		handleUpdateParent(newTime);
	}
	

  	return (
    	<Card className={classes.advancedCard}>
			<CardHeader title="Mini Display Timing" />
	  		<CardContent className={classes.advancedContentVertical}>
				<Box className={classes.advancedContent}>
				{mtime.steps.map((row, i) =>(
					<Box key={i} className={classes.miniOnOff}>
						<Typography>{i+1}</Typography>
	  					<TextField 
							name="on"
							label="On"
							value={row[0].toString()} 
							className={classes.timingInput} 
							onChange={(e) => handleChangeTiming(e, i)}
							type="number" 
							inputProps={{min: '0', max:max.toString(), step:'50', style: {textAlign:'center'}}}
						/>
						<TextField 
							name="off"
							label="Off"
							value={row[1].toString()} 
							className={classes.timingInput} 
							onChange={(e) => handleChangeTiming(e, i)}
							type="number" 
							inputProps={{min: '0', max:max.toString(), step:'50', style: {textAlign:'center'}}}
						/>
					</Box>
				))}
				</Box>
				<Box className={classes.advancedContent}>
	  				<TextField 
							id="duration" 
							name="duration"
							label="Duration"
							value={mtime.duration.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeTiming}
							type="number" 
							inputProps={{min: '0', max:"255", step:'1', style: {textAlign:'center'}}}
					/>
					<TextField 
							id="cycles" 
							name="cycles"
							label="Cycles"
							value={mtime.cycles.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeTiming}
							type="number" 
							inputProps={{min: '0', max:"255", step:'1', style: {textAlign:'center'}}}
					/>
				</Box>
	  		</CardContent>
	  	</Card>
  );
}
